import { render, staticRenderFns } from "./Tarifario.vue?vue&type=template&id=33730c2e"
import script from "./Tarifario.vue?vue&type=script&lang=js"
export * from "./Tarifario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports